<template>
  <div class="plastic-bags-with-handles with-slider">
    <!--type slider (desktop)-->
    <slider-select
      v-if="fields[PlasticBagsWithHandlesFields.type].options?.length"
      v-model="form.type"
      class="main-slider"
    >
      <slider-select-option
        v-for="option in fields[PlasticBagsWithHandlesFields.type].options"
        :key="option.value"
        :value="option.value"
        :label="option.value"
        :image-src="uploadsUrl(option?.thumbnail?.data?.attributes.url || '')"
      />
    </slider-select>
    <i-form
      v-scroll-to-invalid
      class="form"
      name="plastic-bags-with-handles-form"
      @submit="handleSubmit"
    >
      <div class="type">
        <strapi-label
          v-if="labels[PlasticBagsWithHandlesLabels.type]"
          :label="labels[PlasticBagsWithHandlesLabels.type]"
        />
        <div class="form-field-group">
          <!--type field-->
          <zaproo-select
            v-if="fields[PlasticBagsWithHandlesFields.type]"
            v-model="form.type"
            :removable="false"
            searchable
            highlight
            :no-result-label="$t('No results found')"
            no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
            name="type"
            :placeholder="$t('Select option')"
            :rules="fieldRules[PlasticBagsWithHandlesFields.type]"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.type]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PlasticBagsWithHandlesFields.type]
                .options"
              :key="option.value"
              :value="option.value"
              :label="option.title"
            />
          </zaproo-select>
        </div>
      </div>

      <div
        v-if="fields[PlasticBagsWithHandlesFields.type].options?.length"
        class="form-slider"
      >
        <!--type slider (max to desktop)-->
        <slider-select v-model="form.type">
          <slider-select-option
            v-for="option in fields[PlasticBagsWithHandlesFields.type].options"
            :key="option.value"
            :value="option.value"
            :label="option.value"
            :image-src="
              uploadsUrl(option?.thumbnail?.data?.attributes.url || '')
            "
          />
        </slider-select>
      </div>

      <div class="dimensions mt-6">
        <strapi-label
          v-if="labels[PlasticBagsWithHandlesLabels.dimensions]"
          :label="labels[PlasticBagsWithHandlesLabels.dimensions]"
        />
        <div class="form-field-third">
          <!--length field-->
          <zaproo-input
            v-if="fields[PlasticBagsWithHandlesFields.length]"
            v-model="form.length"
            type="number"
            name="length"
            :rules="fieldRules[PlasticBagsWithHandlesFields.length]"
            :placeholder="
              fields[PlasticBagsWithHandlesFields.length].placeholder
            "
            :description="
              fields[PlasticBagsWithHandlesFields.length].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.length]"
              />
            </template>
          </zaproo-input>

          <!--width field-->
          <zaproo-input
            v-if="fields[PlasticBagsWithHandlesFields.width]"
            v-model="form.width"
            type="number"
            name="width"
            :rules="fieldRules[PlasticBagsWithHandlesFields.width]"
            :placeholder="
              fields[PlasticBagsWithHandlesFields.width].placeholder
            "
            :description="
              fields[PlasticBagsWithHandlesFields.width].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.width]"
              />
            </template>
          </zaproo-input>

          <!--folding field-->
          <zaproo-input
            v-if="fields[PlasticBagsWithHandlesFields.folding]"
            v-model="form.folding"
            type="number"
            name="folding"
            :rules="fieldRules[PlasticBagsWithHandlesFields.folding]"
            :placeholder="
              fields[PlasticBagsWithHandlesFields.folding].placeholder
            "
            :description="
              fields[PlasticBagsWithHandlesFields.folding].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.folding]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="material mt-6">
        <strapi-label
          v-if="labels[PlasticBagsWithHandlesLabels.material]"
          :label="labels[PlasticBagsWithHandlesLabels.material]"
        />
        <div class="form-field-group">
          <!--material field-->
          <zaproo-select
            v-if="fields[PlasticBagsWithHandlesFields.material]"
            v-model="form.material"
            :removable="false"
            name="material"
            :placeholder="$t('Select option')"
            :rules="fieldRules[PlasticBagsWithHandlesFields.material]"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.material]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PlasticBagsWithHandlesFields.material]
                .options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--thickness field-->
          <zaproo-input
            v-if="fields[PlasticBagsWithHandlesFields.thickness]"
            v-model="form.thickness"
            type="number"
            name="thickness"
            :rules="fieldRules[PlasticBagsWithHandlesFields.thickness]"
            :placeholder="
              fields[PlasticBagsWithHandlesFields.thickness].placeholder
            "
            :description="
              fields[PlasticBagsWithHandlesFields.thickness].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.thickness]"
              />
            </template>
          </zaproo-input>
        </div>
        <div class="form-field-group">
          <!--mainColor field-->
          <zaproo-select
            v-if="fields[PlasticBagsWithHandlesFields.mainColor]"
            v-model="form.mainColor"
            :removable="false"
            name="mainColor"
            :placeholder="$t('Select option')"
            :rules="fieldRules[PlasticBagsWithHandlesFields.mainColor]"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.mainColor]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PlasticBagsWithHandlesFields.mainColor]
                .options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--otherMainColor field-->
          <zaproo-input
            v-if="
              isOtherMainColor &&
              fields[PlasticBagsWithHandlesFields.otherMainColor]
            "
            v-model="form.otherMainColor"
            name="otherMainColor"
            :rules="fieldRules[PlasticBagsWithHandlesFields.otherMainColor]"
            :placeholder="
              fields[PlasticBagsWithHandlesFields.otherMainColor].placeholder
            "
            :description="
              fields[PlasticBagsWithHandlesFields.otherMainColor].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.otherMainColor]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="print mt-6">
        <strapi-label
          v-if="labels[PlasticBagsWithHandlesLabels.print]"
          :label="labels[PlasticBagsWithHandlesLabels.print]"
        />
        <div class="form-field-group">
          <!--numberOfPrintColorsFirstSide field-->
          <zaproo-select
            v-if="
              fields[PlasticBagsWithHandlesFields.numberOfPrintColorsFirstSide]
            "
            v-model="form.numberOfPrintColorsFirstSide"
            :removable="false"
            :rules="
              fieldRules[
                PlasticBagsWithHandlesFields.numberOfPrintColorsFirstSide
              ]
            "
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsFirstSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[
                    PlasticBagsWithHandlesFields.numberOfPrintColorsFirstSide
                  ]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsWithHandlesFields.numberOfPrintColorsFirstSide
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--firstSidePrintArea field-->
          <zaproo-select
            v-if="
              isPrintColorsFirstSide &&
              fields[PlasticBagsWithHandlesFields.firstSidePrintArea]
            "
            v-model="form.firstSidePrintArea"
            :removable="false"
            :placeholder="$t('Select option')"
            :rules="fieldRules[PlasticBagsWithHandlesFields.firstSidePrintArea]"
            dropdown-classes="py-2 mt-2"
            name="firstSidePrintArea"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.firstSidePrintArea]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsWithHandlesFields.firstSidePrintArea
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>

        <div class="form-field-group">
          <!--numberOfPrintColorsSecondSide field-->
          <zaproo-select
            v-if="[PlasticBagsWithHandlesFields.numberOfPrintColorsSecondSide]"
            v-model="form.numberOfPrintColorsSecondSide"
            :removable="false"
            :rules="
              fieldRules[
                PlasticBagsWithHandlesFields.numberOfPrintColorsSecondSide
              ]
            "
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsSecondSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[
                    PlasticBagsWithHandlesFields.numberOfPrintColorsSecondSide
                  ]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsWithHandlesFields.numberOfPrintColorsSecondSide
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--secondSidePrintArea field-->
          <zaproo-select
            v-if="
              isPrintColorsSecondSide &&
              fields[PlasticBagsWithHandlesFields.secondSidePrintArea]
            "
            v-model="form.secondSidePrintArea"
            :removable="false"
            :rules="
              fieldRules[PlasticBagsWithHandlesFields.secondSidePrintArea]
            "
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            name="secondSidePrintArea"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[PlasticBagsWithHandlesFields.secondSidePrintArea]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsWithHandlesFields.secondSidePrintArea
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>

        <div class="form-field-group">
          <!--designFile field-->
          <zaproo-file-input
            v-if="
              isPrintDesignFile &&
              fields[PlasticBagsWithHandlesFields.designFile]
            "
            v-model="form.designFile"
            class="mt-3"
            name="designFiles"
            :rules="fieldRules[PlasticBagsWithHandlesFields.designFile]"
            multiple
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="
              fields[PlasticBagsWithHandlesFields.designFile].placeholder
            "
            file-item-classes="h-10"
            remove-button-classes="!p-0"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsWithHandlesFields.designFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>

      <special-order-form-general-contacts-part
        v-model="form"
        class="general-contacts-form"
        :loading="loading"
      >
        <!--amountPcs field-->
        <zaproo-input
          v-if="fields[PlasticBagsWithHandlesFields.amountPcs]"
          v-model="form.amountPcs"
          type="number"
          name="amountPcs"
          :rules="fieldRules[PlasticBagsWithHandlesFields.amountPcs]"
          :placeholder="
            fields[PlasticBagsWithHandlesFields.amountPcs].placeholder
          "
          :description="
            fields[PlasticBagsWithHandlesFields.amountPcs].description
          "
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[PlasticBagsWithHandlesFields.amountPcs]"
            />
          </template>
        </zaproo-input>
      </special-order-form-general-contacts-part>
    </i-form>
  </div>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../SpecialOrderFormInputLabel.vue";
import {
  PlasticBagsWithHandlesLabels,
  PlasticBagsWithHandlesFields,
} from "./types";
import type {
  StrapiField,
  StrapiLabel as StrapiLabelType,
  StrapiSpecialOrders,
} from "~/types/strapi";

import { getFieldDefaultModel } from "~/modules/special-orders/helpers";

import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import SliderSelect from "~/modules/special-orders/components/SliderSelect/SliderSelect.vue";
import SliderSelectOption from "~/modules/special-orders/components/SliderSelect/SliderSelectOption.vue";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { uploadsUrl } = useStrapiExtend();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);

const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(PlasticBagsWithHandlesLabels));
const fields = computed(() => fieldsCollection(PlasticBagsWithHandlesFields));
const fieldRules = useSpecialOrderFieldRules<
  typeof PlasticBagsWithHandlesFields
>(fields.value);

const form = ref<ReturnType<typeof resetForm>>(resetForm());

const isPrintColorsFirstSide = computed(
  () => form.value.numberOfPrintColorsFirstSide !== "0",
);

const isPrintColorsSecondSide = computed(
  () => form.value.numberOfPrintColorsSecondSide !== "0",
);

const isPrintDesignFile = computed<boolean>(
  () => isPrintColorsFirstSide.value || isPrintColorsSecondSide.value,
);

const isOtherMainColor = computed(() => form.value.mainColor === "other");

function resetForm() {
  return {
    type: getFieldDefaultModel(fields.value[PlasticBagsWithHandlesFields.type]),
    length: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.length],
    ),
    width: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.width],
    ),
    folding: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.folding],
    ),
    material: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.material],
    ),
    thickness: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.thickness],
    ),
    mainColor: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.mainColor],
    ),
    otherMainColor: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.otherMainColor],
    ),
    numberOfPrintColorsFirstSide: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.numberOfPrintColorsFirstSide],
    ),
    firstSidePrintArea: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.firstSidePrintArea],
    ),
    numberOfPrintColorsSecondSide: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.numberOfPrintColorsSecondSide],
    ),
    secondSidePrintArea: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.secondSidePrintArea],
    ),
    amountPcs: getFieldDefaultModel(
      fields.value[PlasticBagsWithHandlesFields.amountPcs],
    ),
    designFile: [],
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    otherMainColor: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PlasticBagsWithHandlesFields.otherMainColor],
        ),
      ref: isOtherMainColor,
    },
    designFile: {
      default: () => [],
      ref: isPrintDesignFile,
    },
    firstSidePrintArea: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PlasticBagsWithHandlesFields.firstSidePrintArea],
        ),
      ref: isPrintColorsFirstSide,
    },
    secondSidePrintArea: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PlasticBagsWithHandlesFields.secondSidePrintArea],
        ),
      ref: isPrintColorsSecondSide,
    },
  },
  form,
);
</script>
